/*
 * A pet's sex as the API numbers it: Male 0, Female 1 (mpgadmin PetGender,
 * G106). Every form here used to send `female ? 1 : 2` and read 2 as male,
 * so a male pet saved on the booking site showed no sex in the admin, and a
 * male pet entered in the admin (0) showed none here (H2, found 12 Oct 2026).
 * Everything that sends or reads a pet's sex goes through these two.
 */
export type PetGenderName = 'Male' | 'Female' | '';

/** The number the API takes, or null when none is chosen. */
export const genderToApi = (gender?: string | null): 0 | 1 | null => {
  const g = (gender || '').trim().toLowerCase();
  if (g === 'male') return 0;
  if (g === 'female') return 1;
  return null;
};

/**
 * The name for a number the API holds. 2 is male too: the booking site wrote
 * it for every male pet until this fix, and the API turns those rows into 0
 * (its PetGenderBookingSiteMale migration), but a row read before that runs
 * must still say Male.
 */
export const genderFromApi = (value?: number | string | null): PetGenderName => {
  const n = typeof value === 'string' && /^\d+$/.test(value) ? Number(value) : value;
  if (n === 0 || n === 2) return 'Male';
  if (n === 1) return 'Female';
  return '';
};
